import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08cef712"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Coderhouse",
    src: "../../assets/logos_coderhouse.png"
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ingresa a la Plataforma de Educación", -1))
const _hoisted_3 = { class: "login-inputs-container" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-field p-grid" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "userName",
  class: "p-text-left p-col-4"
}, "Usuario", -1))
const _hoisted_7 = { class: "p-col-8 p-text-left" }
const _hoisted_8 = { class: "p-field p-grid" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "p-text-left p-col-4"
}, "Contraseña", -1))
const _hoisted_10 = { class: "p-col-8 p-text-left" }
const _hoisted_11 = { class: "p-input-icon-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "login" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _hoisted_2
    ]),
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_3, [
        (_ctx.error)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              life: 1500,
              sticky: false,
              severity: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.error?.message || _ctx.error), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_InputText, {
                class: "p-inputtext-lg",
                id: "userName",
                type: "text",
                modelValue: _ctx.data.userName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.userName) = $event)),
                placeholder: "Ingrese su nombre de usuario",
                size: "30",
                onKeyup: _withKeys(_ctx.submit, ["enter"])
              }, null, 8, ["modelValue", "onKeyup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_InputText, {
                  class: "p-inputtext-lg",
                  id: "password",
                  type: _ctx.data.showPassword ? 'text' : 'password',
                  modelValue: _ctx.data.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.password) = $event)),
                  onKeyup: _withKeys(_ctx.submit, ["enter"])
                }, null, 8, ["type", "modelValue", "onKeyup"]),
                _createElementVNode("i", {
                  onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.showPassword=false)),
                  onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.showPassword=true)),
                  class: _normalizeClass(["pi", _ctx.data.showPassword ? 'pi-eye-slash' : 'pi-eye'])
                }, null, 34)
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_Button, {
          class: "p-button-help",
          icon: "pi pi-sign-in",
          label: "Login",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit()))
        })
      ])
    ]),
    _: 1
  }))
}